module.exports = __webpack_public_path__ + "img/cal32.eb319392.svg";